export function checkoutUserIsStale(user, cart) {
  if (!cart?.id) return false

  const order = user?.current_order

  return (
    order?.id !== cart.id ||
    (order.shipping_method_range_id ?? null) !==
      (cart.shipping_method_range_id ?? null)
  )
}

export async function syncCheckoutUser({ store, $auth }) {
  if (checkoutUserIsStale(store.state.auth.user, store.state.cart)) {
    await $auth.fetchUser().catch(() => {})
  }
}
